import { combineReducers } from 'redux';
import { PullRequest } from '../../models/PullRequest';
import { SecurityAction } from './actions';

export type SecurityStore = {
  pullRequest?: PullRequest;
};

export const modalInitialState = {};

const selection = (
  state: SecurityStore = {},
  action: SecurityAction
): SecurityStore => {
  switch (action.type) {
    case 'SECURITY/CLEAR_SELECTED_REVIEW':
      delete state.pullRequest;
      return { ...state };
    case 'SECURITY/SELECT_REVIEW':
      const { pullRequest } = action;
      return {
        ...state,
        pullRequest,
      };
    default:
      return state;
  }
};

export const store = combineReducers({
  selection,
});
